import { render, staticRenderFns } from "./TableCommunityFinances.vue?vue&type=template&id=25a505c6&"
import script from "./TableCommunityFinances.vue?vue&type=script&lang=js&"
export * from "./TableCommunityFinances.vue?vue&type=script&lang=js&"
import style0 from "./TableCommunityFinances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports